module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_ok-94bcff65a60754952f4c507048530ea6.png";